(function ($, _, Drupal) {
  Drupal.behaviors.heroParallax = {
    attach: _.once(function (context) {
      console.log('now working with parallax js');
      new Rellax('.hero-banner-global__content', {
        speed: -5,
        center: true,
        min: 0,
        max: 400,
        mobile: true,
        scale: 1.0,
        mapBreakpoints: {
          'xs': 568,
          'sm': 768,
          'md': 968,
          'lg': 1200
        }
      });
    })
  }
})(jQuery, _, Drupal);
